import { signal } from '@preact/signals';
import type { CategoryTreeCategory } from 'components/modal/categories/signals.ts';
import type { CategoryData } from 'service/category/model';

export const phraseCategories = signal<CategoryData[] | null>(null);
// Categories that are displayed in the category list on Bazar page
export const availableCategories = signal<CategoryTreeCategory[]>([]);

export const expandedCategories = signal<Record<number, boolean>>({});
export const categoryCountsOverride = signal<Record<number, number>>({});
export const hideOffersCount = signal(false);
